import { removeNonIntegersFromString } from "@/helpers/string-helpers";

export interface CnpjApiResponse {
  razao_social?: string;
  nome_fantasia?: string | null;
  fantasia?: string | null; // fallback alguns serviços usam outra chave
}

/**
 * Busca informações de CNPJ em API pública. Pode ser substituído por backend próprio futuramente.
 * Retorna nome fantasia (ou razão social como fallback).
 */
export async function fetchCnpjData(
  rawCnpj: string
): Promise<{ fantasy: string; companyName: string } | null> {
  if (!rawCnpj) return null;
  const cnpj = removeNonIntegersFromString(rawCnpj);
  if (cnpj.length !== 14) return null;

  try {
    const response = await fetch(`https://publica.cnpj.ws/cnpj/${cnpj}`);
    if (!response.ok) return null;
    const data: CnpjApiResponse = await response.json();
    const fantasy = (data.nome_fantasia || data.fantasia || "").trim();
    const razao = (data.razao_social || "").trim();
    const companyName = fantasy || razao;
    if (!companyName) return null;
    return { fantasy: fantasy || razao, companyName };
  } catch (e) {
    return null; // silencioso; UX não deve travar registro
  }
}
